import { useContext } from 'react';
import AppContext from '../components/App/AppContext';

const useError = () => {
  const { error, setError } = useContext(AppContext);
  return { error, setError };
};

export default useError;
